/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Settings hook
 * @author Dustin Gage
 */

import { createContext, useContext } from "react";

import { SiteSettings } from "../types";

export const __SettingsContext = createContext<SiteSettings>({} as any);

export function useSettings(): SiteSettings {
	return useContext(__SettingsContext);
}
